import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getFilterControls = (state: ContentPluginRootState) => state.data.results?.filterControls;

export default getFilterControls;
